export default __webpack_public_path__ + "static/media/img-butcher-selected-old.9c6f1bf6.svg";